define((require) => {
    "use strict";

    var $                      = require("jquery"),
        _                      = require("underscore"),
        Marionette             = require("marionette"),
        TweenMax               = require("TweenMax"),
        CommentView            = require("ui/comments/CommentView");

    var doc = $("html");

    /**
     * Wrapper around a comment view for display in the editor. Manages positioning of the comment.
     *
     * @author Bruce Mackenzie Nielsen
     * @class EditorCommentView
     * @constructor
     *
     * @cfg {Comment} model The comment to render.
     * @cfg {EditorViewModel} viewModel The editor view model.
     */
    return Marionette.ItemView.extend({
        tagName: "div",

        className: "editor-comment",

        template: function() { return ""; },

        commentView: null,

        moveStartPosition: null,

        viewModel: null,

        events: {
            "mousedown": "_mouseDownHandler",
            "click": "_moveToTop"
        },

        initialize: function() {
            this.viewModel = this.options.viewModel;
            this.listenTo(this.model, "destroy", this.close);
            this.listenTo(this.model, "change:top change:left change:scaleFactor", function(commentModel, value, options) {
                // Update comment position and save the model
                this._setPosition(null, options && options.animate);
            });
        },

        _moveToTop: function() {
            this.$el.css("zIndex", this.options.editorCommentsRenderer.moveCommentToTop(this.model));
            // Trigger a comment view click event
            this.trigger("commentViewClicked");
        },

        _mouseDownHandler: function(event) {
            // Only consider the left mouse button
            if (event.which !== 1) {
                return;
            }

            // Ignore clicks on scroll bars
            if (event.target.className.indexOf("comment-collection-region") !== -1) {
                return;
            }

            // Make this the topmost comment
            this._moveToTop();

            // Store the initial mouse coordinates
            this.moveStartPosition = {
                left: event.pageX,
                top: event.pageY
            };

            // Add move and up handlers to the container
            doc.on("mousemove", this._mouseMoveHandler.bind(this));
            doc.on("mouseup", this._mouseUpHandler.bind(this));

            event.preventDefault();
        },

        _mouseMoveHandler: function(event) {
            if (this.moveStartPosition) {
                var left = event.pageX - this.moveStartPosition.left,
                    top = event.pageY - this.moveStartPosition.top;

                this._setPosition({
                    left: left,
                    top: top
                });

                event.preventDefault();
            }
        },

        _mouseUpHandler: function(event) {
            if (this.moveStartPosition) {
                // Did we move? No need to burden the backend with a save otherwise...
                var deltaX = event.pageX - this.moveStartPosition.left,
                    deltaY = event.pageY - this.moveStartPosition.top;

                if (deltaX !== 0 || deltaY !== 0) {
                    const scaleFactor = this.viewModel.get("zoomModel").get("scale");
                    // Apply the offset to the model. If negative, set to 0.
                    this.model.set({
                        left: Math.max((Math.floor(this.model.get("left") + deltaX / scaleFactor)), 0),
                        top:  Math.max((Math.floor(this.model.get("top")  + deltaY / scaleFactor)), 0)
                    });

                    event.preventDefault();

                    this.trigger("moved");
                }
            }

            // Clean up
            this.moveStartPosition = null;
            doc.off("mousemove");
            doc.off("mouseup");
        },

        /**
         * Sets the position of the comment.
         *
         * @param {Object} [offset] If specified, offsets the position. Should be an object with both left and top properties.
         * @private
         */
        _setPosition: function(offset, animate) {
            const scaleFactor = this.viewModel.get("zoomModel").get("scale");
            const position = this.model.getScaledPosition(scaleFactor);

            if (offset) {
                position.left += offset.left;
                position.top += offset.top;
            }

            position.left = Math.max(0, position.left);
            position.top = Math.max(0, position.top);

            if (animate) {
                TweenMax.to(this.el, 0.5, {x: position.left, y: position.top});
            } else {
                TweenMax.set(this.el, {x: position.left, y: position.top});
            }

            var changedAttributes = this.model.changedAttributes();

            // Save non-empty comment position if "top" of "left" has been changed
            if ((_.has(changedAttributes, "top") || _.has(changedAttributes, "left")) && this.model.get("content")) {
                this.model.saveLater();
            }
        },

        /**
         * Gets the bounds of the comment, in pixels, relative to the center of the scene.
         * @returns {{left: number, right: number, top: number, bottom: number}}
         */
        getBounds: function() {
            const scaleFactor = this.viewModel.get("zoomModel").get("scale");
            const position = this.model.getScaledPosition(scaleFactor);

            return {
                left: position.left,
                right: position.left + this.$el.width(),
                top: position.top,
                bottom: position.top + this.$el.height()
            };
        },

        getSceneID: function() {
            return this.model.sceneID || this.model.scene;
        },

        onRender: function() {
            // Render the actual comment view inside the container
            this.commentView = new CommentView({model: this.model, viewModel: this.options.viewModel});
            this.$el.append(this.commentView.render().$el);

            // Position the comment
            this._setPosition();
            this.$el.css("zIndex", this.model.get("zIndex") || 0);
        },

        onShow: function() {
            this.commentView.addedToDOM();
        },

        getBoundingRect: function() {
            return this.el.getBoundingClientRect();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/EditorCommentView.js